import NotFoundPage from './NotFoundPage';
export {default as route} from './route';

export default NotFoundPage;
